// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CheckShield24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckShield24CircleFilled: FC<CheckShield24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path d="m20.6 13.9-5.65 5.65-3.525-3.525L12.85 14.6l2.1 2.1 4.225-4.225L20.6 13.9Z" />
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-5.738-9.988C11.771 24.087 13.683 25.418 16 26c2.317-.583 4.23-1.913 5.738-3.988S24 17.633 24 15.1V9l-8-3-8 3v6.1c0 2.533.754 4.838 2.262 6.912Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default CheckShield24CircleFilled;
